import React, { Component, useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { styled, useTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LaunchIcon from '@mui/icons-material/Launch';
import ClearIcon from '@mui/icons-material/Clear';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import BorderOuterIcon from '@mui/icons-material/BorderOuter';
import BorderTopIcon from '@mui/icons-material/BorderTop';
import BorderBottomIcon from '@mui/icons-material/BorderBottom';
import BorderClearIcon from '@mui/icons-material/BorderClear';
import BorderLeftIcon from '@mui/icons-material/BorderLeft';
import BorderRightIcon from '@mui/icons-material/BorderRight';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import SvgIcon from '@mui/material/SvgIcon';
import FormControlLabel from '@mui/material/FormControlLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { ColorPickerDialog  } from "../util/color";
import { validHex, color, hexToXY, xyToRgb } from '@uiw/color-convert';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import * as XXE from '../xxe/xxeclient/xxeclient.js';
import {NumberField} from "../NumberField";
import debounce from 'lodash.debounce';

const convertColor = (value) => {
  if (validHex(value)) {
    const c = color(value).rgb;
    return `(r:${c.r}, g:${c.g}, b:${c.b})`;
  }
  return '';
};

function TableSvgIcon() {
  return (
    <SvgIcon>
          <svg x="0px" y="0px" viewBox="0 0 32 32" enable-background="new 0 0 32 32">
              <g>
                  <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M1.5,8.51v20.01h28V8.51H1.5z"/>
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,12.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,16.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,20.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,24.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M8.5,28V9" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M15.5,28V9" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M22.5,28V9" />

                  <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" stroke="#5d5d60" stroke-width="1"
                      stroke-miterlimit="10" d="M1.5,4.5V8.5h28V4.5H1.5z" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M8.5,8V5" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M15.5,8V5" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M22.5,8V5" />
              </g>
          </svg>
    </SvgIcon>
  );
}

function HeaderTableSvgIcon() {
  return (
    <SvgIcon>
          <svg x="0px" y="0px" viewBox="0 0 32 32" enable-background="new 0 0 32 32">
              <g>
                  <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M1.5,8.51v20.01h28V8.51H1.5z"/>
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,12.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,16.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,20.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M2,24.5h27" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M8.5,28V9" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M15.5,28V9" />
                  <path fill="none" stroke="#5d5d60" stroke-width="1" stroke-miterlimit="10" d="M22.5,28V9" />

                  <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#5899ff" stroke="#10419a" stroke-width="1"
                      stroke-miterlimit="10" d="M1.5,4.5V8.5h28V4.5H1.5z" />
                  <path fill="none" stroke="#10419a" stroke-width="1" stroke-miterlimit="10" d="M8.5,8V5" />
                  <path fill="none" stroke="#10419a" stroke-width="1" stroke-miterlimit="10" d="M15.5,8V5" />
                  <path fill="none" stroke="#10419a" stroke-width="1" stroke-miterlimit="10" d="M22.5,8V5" />
              </g>
          </svg>
    </SvgIcon>
  );
}

function CreateTableDialog (props) {
    const {
        title = 'Insert Table',
        open,
        onSave,
        onCancel,
       ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(false);
    const [colsValue, setColsValue] = useState(2);
    const [rowsValue, setRowsValue] = useState(2);
    const [withHeader, setWithHeader] = useState(false);


    useEffect(() => {
        if ( open  ) {
            setOkEnabled(false);
            setColsValue(2);
            setRowsValue(2);
            setWithHeader(false);
        }
    },[open,document]);


    const onOkClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave({
                cols: colsValue,
                rows: rowsValue,
                header: withHeader,
            });
        }
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleColsChange = (event) => {
        let v = event.target.value;
        if ( !(typeof v === 'number')) {
            v = parseInt(event.target.value);
        }
        if ( Number.isNaN(v)) {
            v = '';
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        // save('cols', `${v}`);
    };

    const handleColsIncrement = () => {
        let v = colsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 0;
        }
        if ( !(typeof v === 'number') ) {
            v = parseInt(colsValue);
        }
        v = v + 1;
        if ( v > 100 ) {
            v = 100;
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        // save('cols', `${v}`);
    };

    const handleColsDecrement = () => {
        let v = colsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 2;
        }
        v = v - 1;
        if ( v < 1 ) {
            v = 1;
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        // save('cols', `${v}`);
    };

    const handleRowsChange = (event) => {
        let v = event.target.value;
        if ( !(typeof v === 'number')) {
            v = parseInt(event.target.value);
        }
        if ( Number.isNaN(v)) {
            v = '';
        }
        // console.log('set cols = ' + v);
        setRowsValue(v);
        // save('cols', `${v}`);
    };

    const handleRowsIncrement = () => {
        let v = rowsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 0;
        }
        if ( !(typeof v === 'number') ) {
            v = parseInt(colsValue);
        }
        v = v + 1;
        if ( v > 100 ) {
            v = 100;
        }
        // console.log('set cols = ' + v);
        setRowsValue(v);
        // save('cols', `${v}`);
    };

    const handleRowsDecrement = () => {
        let v = rowsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 2;
        }
        v = v - 1;
        if ( v < 1 ) {
            v = 1;
        }
        // console.log('set cols = ' + v);
        setRowsValue(v);
        // save('cols', `${v}`);
    };

    const handleHeaderChange = (event) => {
        setWithHeader(event.target.checked);
    }

    return (
      <Dialog
        maxWidth={'900px'}
        open={open}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: 600,
              maxWidth: 900,
              maxHeight: 550,
              minHeight: 300,
            }
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '180px', marginRight: 0, fontSize: 'inherit' }}>Number of Columns:</Typography>
                    <NumberField value={colsValue} size="small" min={1} max={120} sx={{ mr: '10px', }}
                        onIncrement={handleColsIncrement} onDecrement={handleColsDecrement}
                        onChange={handleColsChange} />
                </Box>
                <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '180px', marginRight: 0, fontSize: 'inherit' }}>Number of Rows:</Typography>
                    <NumberField value={rowsValue} size="small" min={1} max={100} sx={{ mr: '10px', }}
                        onIncrement={handleRowsIncrement} onDecrement={handleRowsDecrement}
                        onChange={handleRowsChange} />
                </Box>
                <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '180px', marginRight: 0, fontSize: 'inherit' }}>Add Header:</Typography>
                    <FormControlLabel
                        sx={{pl: 1}}
                        label={withHeader ? 'Yes' : 'No'}
                        slotProps={{
                            typography: {
                                sx: {pl: 2}
                            }
                        }}
                        control={<Checkbox value={withHeader} icon={<TableSvgIcon />} checkedIcon={<HeaderTableSvgIcon />} onChange={handleHeaderChange} />}
                    />
                </Box>
            </DialogContent>
        <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
          <Box>
            <Button variant="outlined" onClick={() => onOkClick()} sx={{ minWidth: '7em' }} >OK</Button>
            <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
          </Box>
        </DialogActions>
      </Dialog>
    
        );
    
}


function TableEntryPanel (props) {
    const {
        document,
        id,
        propertyNode,
        open,
        onSave,
        onCancel,
        visible,
        ...other
    } = props;

    const [alignValue, setAlignValue] = useState('left');
    const [valignValue, setValignValue] = useState('top');
    const [rowsepValue, setRowsepValue] = useState(''); // unset
    const [colsepValue, setColsepValue] = useState(''); // unset
    const [colsValue, setColsValue] = useState(2);
    const [orientValue, setOrientValue] = useState('');
    const [frameValue, setFrameValue] = useState('');
    const [colnameValue, setColnameValue] = useState('');
    const [colnameChanged, setColnameChanged] = useState(false);
    const [colwidthValue, setColwidthValue] = useState('');
    const [colwidthChanged, setColwidthChanged] = useState(false);
    const [rowspanValue, setRowspanValue] = useState(1);
    const [colspanValue, setColspanValue] = useState(1);
    const [bgcolorValue, setBgcolorValue] = useState(''); // unset
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [colorDialogValue, setColorDialogValue] = useState('#000000');
    const [pasteColumnBeforeEnable, setPasteColumnBeforeEnable] = useState(false);
    const [pasteColumnAfterEnable, setPasteColumnAfterEnable] = useState(false);
    const [pasteRowBeforeEnable, setPasteRowBeforeEnable] = useState(false);
    const [pasteRowAfterEnable, setPasteRowAfterEnable] = useState(false);
    // const [tableInsertDialogOpen, setTableInsertDialogOpen] = useState(false);
 
    useEffect(() => {
        if ( propertyNode?.attributes?.align) {
            setAlignValue(propertyNode?.attributes?.align);
        } else {
            setAlignValue('');
        }
        if ( propertyNode?.attributes?.valign) {
            setValignValue(propertyNode?.attributes?.valign);
        } else {
            setValignValue('');
        }
        if ( propertyNode?.attributes?.rowsep) {
            setRowsepValue(propertyNode?.attributes?.rowsep);
        } else {
            setRowsepValue('');
        }
        if ( propertyNode?.attributes?.colsep) {
            setColsepValue(propertyNode?.attributes?.colsep);
        } else {
            setColsepValue('');
        }
        if ( propertyNode?.attributes?.bgcolor) {
            setBgcolorValue(propertyNode.attributes.bgcolor);
        } else {
            setBgcolorValue('');
        }
        if ( propertyNode?.attributes?.cols) {
            let c = parseInt(propertyNode.attributes.cols);
            if ( Number.isNaN(c) ) {
                c = 1;
            }
            setColsValue(c);
        } else {
            setColsValue(2);
        }
        if ( propertyNode?.attributes?.morerows) {
            let r = parseInt(propertyNode.attributes.morerows);
            if ( Number.isNaN(r) ) {
                r = 0;
            }
            setRowspanValue(r+1);
        } else {
            setRowspanValue(1);
        }
        if ( propertyNode?.attributes?.orient) {
            setOrientValue(propertyNode.attributes.orient);
        } else {
            setOrientValue('');
        }
        if ( propertyNode?.attributes?.frame) {
            setFrameValue(propertyNode.attributes.frame);
        } else {
            setFrameValue('');
        }
        if ( propertyNode?.attributes?.colname) {
            setColnameValue(propertyNode.attributes.colname);
        } else {
            setColnameValue('');
        }
        setColnameChanged(false);
        if ( propertyNode?.attributes?.colwidth) {
            setColwidthValue(propertyNode.attributes.colwidth);
        } else {
            setColwidthValue('');
        }
        setColwidthChanged(false);
        if ( propertyNode?.properties?.COLSPAN ) {
            setColspanValue(propertyNode.properties.COLSPAN);
        } else {
            setColspanValue(1);
        }
        if ( propertyNode?.properties?.pasteColumnBefore ) {
            setPasteColumnBeforeEnable(propertyNode.properties.pasteColumnBefore);
        } else {
            setPasteColumnBeforeEnable(false);
        }
        if ( propertyNode?.properties?.pasteColumnAfter ) {
            setPasteColumnAfterEnable(propertyNode.properties.pasteColumnAfter);
        } else {
            setPasteColumnAfterEnable(false);
        }
        if ( propertyNode?.properties?.pasteRowBefore ) {
            setPasteRowBeforeEnable(propertyNode.properties.pasteRowBefore);
        } else {
            setPasteRowBeforeEnable(false);
        }
        if ( propertyNode?.properties?.pasteRowAfter ) {
            setPasteRowAfterEnable(propertyNode.properties.pasteRowBefore);
        } else {
            setPasteRowAfterEnable(false);
        }
    },[propertyNode]);

    

    const save = (name, value, options) => {
        const v = value !== '' ? value : null;
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        propNode.attributes[name] = v;
        if ( typeof onSave === 'function') {
            onSave(propNode, options);
        }

    }

    const getAlignIcon = (align) => {
        switch (align) {
            case 'right':
                return <FormatAlignRightIcon fontSize="inherit"/>;
            case 'center':
                return <FormatAlignCenterIcon fontSize="inherit"/>;
            case 'justify':
                return <FormatAlignJustifyIcon fontSize="inherit"/>;
            default:
                return <FormatAlignLeftIcon fontSize="inherit"/>;
        }
    }

    const getValignIcon = (valign) => {
        switch (valign) {
            case 'middle':
                return <VerticalAlignCenterIcon fontSize="inherit"/>;
            case 'bottom':
                return <VerticalAlignBottomIcon fontSize="inherit"/>;
            default:
                return <VerticalAlignTopIcon fontSize="inherit"/>;
        }
    }

    const getRowsepIcon = (rowsep) => {
        switch (rowsep) {
            case '1':
                return <BorderBottomIcon fontSize="inherit"/>;
            default:
                return <BorderClearIcon fontSize="inherit" />;
        }
    }

    const getColsepIcon = (colsep) => {
        switch (colsep) {
            case '1':
                return <BorderRightIcon fontSize="inherit"/>;
            default:
                return <BorderClearIcon fontSize="inherit"/>;
        }

    }

    const getFrameIcon = (frame) => {
        switch (frame) {
            case 'none':
                return <BorderClearIcon fontSize="inherit"/>;
            case 'top':
                return <BorderTopIcon fontSize="inherit" />;
            case 'bottom':
                return <BorderBottomIcon fontSize="inherit"/>;
            case 'sides':
                return (
                    <Box sx={{position: 'relative', top: '3px'}}>
                        <BorderLeftIcon fontSize="inherit" />
                        <BorderRightIcon fontSize="inherit" sx={{position: 'absolute', top: 0, left: 0}} />
                    </Box>
                );
            case 'topbot':
                return (
                    <Box sx={{position: 'relative', top: '3px'}}>
                        <BorderTopIcon fontSize="inherit" />
                        <BorderBottomIcon fontSize="inherit" sx={{position: 'absolute', top: 0, left: 0}} />
                    </Box>
                );
            default:
                return <BorderOuterIcon fontSize="inherit"/>;
        }

    }

    const handleAlignClick = (align) => {
        const v = align === alignValue ? '' : align;
        setAlignValue(v);
        save('align', v);
    };

    const handleValignClick = (valign) => {
        const v = valign === valignValue ? '' : valign;
        setValignValue(v);
        save('valign', v);
    };

    const handleRowsepClick = (rowsep) => {
        const v = rowsep === rowsepValue ? '' : rowsep;
        setRowsepValue(v);
        save('rowsep', v);
    };

    const handleColsepClick = (colsep) => {
        const v = colsep === colsepValue ? '' : colsep;
        setColsepValue(v);
        save('colsep', v);
    };

    const getRowsepTitle = (rowsep) => {
        switch (rowsep) {
            case '1':
                return 'Set bottom border';
            default:
                return 'Clear bottom border';
        }
    };

    const getColsepTitle = (colsep) => {
        switch (colsep) {
            case '1':
                return 'Set right border';
            default:
                return 'Clear right border';
        }
    };

    const getFrameTitle = (frame) => {
        switch (frame) {
            case 'none':
                return 'None';
            case 'top':
                return 'Top';
            case 'bottom':
                return 'Bottom';
            case 'sides':
                return 'Sides';
            case 'topbot':
                return 'Top and Bottom';
            default:
                return 'All';
        }
    };

    const handleColorClick = () => {
        setColorDialogOpen(true);
        const v = bgcolorValue && bgcolorValue !== '' ? bgcolorValue : '#FFF';
        // setColorNode(node);
        setColorDialogValue(v);
    };

    const handleColorSave = (value) => {
        setColorDialogOpen(false);
        console.log('color: ' + JSON.stringify(value));
        if (value) {
            setBgcolorValue(value);
            save('bgcolor', value);
        } else {
            setBgcolorValue('');
            save('bgcolor', '');
        }
    };

    const handleColorClearClick = () => {
        setColorDialogOpen(false);
        setBgcolorValue('');
        save('bgcolor', '');
    };

    const handleColsChange = (event) => {
        let v = event.target.value;
        if ( !(typeof v === 'number')) {
            v = parseInt(event.target.value);
        }
        if ( Number.isNaN(v)) {
            v = '';
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        save('cols', `${v}`);
    };

    const handleColsIncrement = () => {
        let v = colsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 0;
        }
        if ( !(typeof v === 'number') ) {
            v = parseInt(colsValue);
        }
        v = v + 1;
        if ( v > 100 ) {
            v = 100;
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        save('cols', `${v}`);
    };

    const handleColsDecrement = () => {
        let v = colsValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 2;
        }
        v = v - 1;
        if ( v < 1 ) {
            v = 1;
        }
        // console.log('set cols = ' + v);
        setColsValue(v);
        save('cols', `${v}`);
    };

    const saveRowSpan = (v) => {
        /*
        const mr = v !== '' && Number.isInteger(v) ?  v - 1 : 0;
        const mrv = mr > 0 ? `${mr}` : '';
        save('morerows', mrv);
        */
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        const options = {
            op: 'SPAN',
            type: 'ROW',
            value: v
        };
        if ( typeof onSave === 'function') {
            onSave(propNode, options);
        }
    }

    const handleRowspanChange = (event) => {
        let v = event.target.value;
        if ( !(typeof v === 'number')) {
            v = parseInt(event.target.value);
        }
        if ( Number.isNaN(v)) {
            v = '';
        }
        // console.log('set cols = ' + v);
        setRowspanValue(v);
        saveRowSpan(v);
        // save('morerows', mrv);
    };

    const handleRowspanIncrement = () => {
        let v = rowspanValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 1;
        }
        if ( !(typeof v === 'number') ) {
            v = parseInt(rowspanValue);
        }
        v = v + 1;
        if ( v > 100 ) {
            v = 100;
        }
        // console.log('set cols = ' + v);
        setRowspanValue(v);
        saveRowSpan(v);
        // save('morerows', `${v}`);
    };

    const handleRowspanDecrement = () => {
        let v = rowspanValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 1;
        }
        v = v - 1;
        if ( v < 1 ) {
            v = 1;
        }
        // console.log('set cols = ' + v);
        setRowspanValue(v);
        saveRowSpan(v);
        // save('cols', `${v}`);
    };

    const handleRunCommand = (cmd,param) => {
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        const options = {
            op: 'CMD',
            cmd: cmd,
            param: param,
        };
        if ( typeof onSave === 'function') {
            onSave(propNode, options);
        }
    };

    const saveColSpan = (v) => {
        // save('morerows', mrv);
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        const options = {
            op: 'SPAN',
            type: 'COL',
            value: v
        };
        if ( typeof onSave === 'function') {
            onSave(propNode, options);
        }
    }

    const handleColspanChange = (event) => {
        let v = event.target.value;
        if ( !(typeof v === 'number')) {
            v = parseInt(event.target.value);
        }
        if ( Number.isNaN(v)) {
            v = '';
        }
        // console.log('set cols = ' + v);
        setColspanValue(v);
        saveColSpan(v);
        // save('morerows', mrv);
    };

    const handleColspanIncrement = () => {
        let v = colspanValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 1;
        }
        if ( !(typeof v === 'number') ) {
            v = parseInt(colspanValue);
        }
        v = v + 1;
        if ( v > 100 ) {
            v = 100;
        }
        // console.log('set cols = ' + v);
        setColspanValue(v);
        saveColSpan(v);
        // save('morerows', `${v}`);
    };

    const handleColspanDecrement = () => {
        let v = colspanValue;
        if ( !(typeof v === 'number')) {
            v = parseInt(v);
        }
        if ( Number.isNaN(v) ) {
            v = 1;
        }
        v = v - 1;
        if ( v < 1 ) {
            v = 1;
        }
        // console.log('set cols = ' + v);
        setColspanValue(v);
        saveColSpan(v);
        // save('cols', `${v}`);
    };

    const handleOrientClick = (orient) => {
        const v = orient === orientValue ? '' : orient;
        setOrientValue(v);
        save('orient', v);
    };

    const handleFrameClick = (frame) => {
        const v = frame === frameValue ? '' : frame;
        setFrameValue(v);
        save('frame', v);
    };

    const handleColnameKeyDown = (event) => {
        if ( event.key === 'Enter' ) {
            event.preventDefault();
            // console.log('Colname Enter detected');
            if ( colnameChanged ) {
                setColnameChanged(false);
                save('colname', colnameValue, {skipRebuild: true});
            }
        }
    };

    const handleColnameChange = (event) => {
        const v = event.target.value;
        if (v !== colnameValue) {
            setColnameValue(v);
            setColnameChanged(true);
            // debouncedColnameChangeHandler(v);
        }
        /*
        const v = event.target.value;
        if ( v !== colnameValue) {
            setColnameValue(v);
            save('colname', v);
        }
        */
    };

    const debouncedColnameChangeHandler = useCallback(
        debounce(value => {
            save('colname', value, {skipRebuild: true});
        }, 3000),
        []
    );

    const handleColwithKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            // console.log('Colname Enter detected');
            if (colwidthChanged) {
                setColwidthChanged(false);
                save('colwidth', colwidthValue, { skipRebuild: true });
            }
        }
    };

    const handleColwidthChange = (event) => {
        const v = event.target.value;
        if ( v !== colwidthValue) {
            setColwidthValue(v);
            setColwidthChanged(true);
            // save('colwidth', v);
            // debouncedColwidthChangeHandler(v);
        }
    };

    const debouncedColwidthChangeHandler = useCallback(
        debounce(value => {
            save('colwidth', value, {skipRebuild: true});
        }, 3000),
        []
    );

    /*
    const handleTableInsert = () => {
        setTableInsertDialogOpen(true);
    }
    */

    return (
        <Box sx={{
            marginTop: 2, visibility: visible,
            position: 'absolute', width: '100%',
            fontSize: '92%'
        }}>
            <Box sx={{ display: 'flex', marginRight: 1, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Element:</Typography>
                <TextField value={propertyNode?.tag ? propertyNode.tag : ''} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: 'inherit', width: '180px' }
                    },
                }} />
            </Box>
            {/* 
            <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>ID:</Typography>
                <TextField readOnly defaultValue={propertyNode?.attributes?.id} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: '90%', width: '180px' }
                    },
                }} />
            </Box>
            */}
            {propertyNode.tag === 'table' &&
                <>
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '120px', marginRight: 0, fontSize: 'inherit' }}>Orientation:</Typography>
                        {['port', 'land'].map(orient =>
                            <Tooltip title={orient === 'port' ? 'Portrait' : 'Landscape'}>
                                {orient === orientValue ?
                                    <IconButton onClick={() => handleOrientClick(orient)} sx={{
                                        backgroundColor: 'primary.main',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: 'primary.dark',
                                        },
                                        borderRadius: '25%',
                                        padding: '6px',
                                    }} >
                                        {orient === 'port' ?
                                            <CropPortraitIcon fontSize="inherit" /> :
                                            <CropLandscapeIcon fontSize="inherit" />
                                        }
                                    </IconButton>
                                    :
                                    <IconButton onClick={() => handleOrientClick(orient)} sx={{
                                        borderRadius: '25%',
                                        padding: '6px',
                                    }}
                                    >
                                        {orient === 'port' ?
                                            <CropPortraitIcon fontSize="inherit" /> :
                                            <CropLandscapeIcon fontSize="inherit" />
                                        }
                                    </IconButton>
                                }
                            </Tooltip>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit', pr: 1 }}>
                        <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>Frame:</Typography>
                        {['all', 'none', 'sides', 'topbot', 'top', 'bottom'].map(frame =>
                            <Tooltip title={getFrameTitle(frame)}>
                                {frame === frameValue ?
                                    <IconButton onClick={() => handleFrameClick(frame)} sx={{
                                        backgroundColor: 'primary.main',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: 'primary.dark',
                                        },
                                        borderRadius: '25%',
                                        padding: '4px',
                                    }} >
                                        {getFrameIcon(frame)}
                                    </IconButton>
                                    :
                                    <IconButton onClick={() => handleFrameClick(frame)} sx={{
                                        borderRadius: '25%',
                                        padding: '4px',
                                    }}
                                    >
                                        {getFrameIcon(frame)}
                                    </IconButton>
                                }
                            </Tooltip>
                        )}
                    </Box>
                </>
            }
            { propertyNode.tag === 'tgroup' &&
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '140px', marginRight: 0, fontSize: 'inherit' }}>Number of Columns:</Typography>
                    <NumberField value={colsValue} size="small" min={1} max={100} sx={{mr: '10px', }} 
                        onIncrement={handleColsIncrement} onDecrement={handleColsDecrement}
                        onChange={handleColsChange} />
            </Box>
            }
            {propertyNode.tag === 'colspec' &&
                <>
                    <Box sx={{ display: 'flex', pr: '20px', alignItems: 'top', fontSize: 'inherit', mt: 2, justifyContent: 'space-between'}}>
                        <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Column Name:</Typography>
                        <TextField value={colnameValue} variant="outlined" onChange={handleColnameChange} size="small"
                            helperText={colnameChanged ? 'Press Enter to commit' : ' '}
                            onKeyDown={handleColnameKeyDown}
                            sx={{
                            // Root class for the input field
                            "& .MuiOutlinedInput-root": {
                                // Class for the border (fieldset)
                                "&.Mui-focused fieldset": {
                                    borderColor: colnameChanged ? "#dce775" : "#326fd1" ,
                                },
                            },
                            
                            }}

                            slotProps={{
                                input: {
                                    sx: { fontSize: 'inherit', width: '170px', outlineColor: 'red' }
                                },
                            }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', pr: '20px', alignItems: 'top', fontSize: 'inherit', mt: 2, justifyContent: 'space-between' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '110px', fontSize: 'inherit' }}>Column Width:</Typography>
                        <TextField value={colwidthValue} variant="outlined" fullWidth onChange={handleColwidthChange} size="small"
                            helperText={colwidthChanged ? 'Press Enter to commit' : ' '}
                            onKeyDown={(handleColwithKeyDown)}
                            sx={{
                            // Root class for the input field
                            "& .MuiOutlinedInput-root": {
                                // Class for the border (fieldset)
                                "&.Mui-focused fieldset": {
                                    borderColor: colwidthChanged ? "#dce775" : "#326fd1" ,
                                },
                            },
                            
                            }}
                            slotProps={{
                                input: {
                                    sx: { fontSize: 'inherit', width: '170px' }
                                },
                            }}
                        />
                    </Box>
                </>
            }
            { ['entry','tgroup','colspec'].includes(propertyNode.tag) &&
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '100px', marginRight: 0, fontSize: 'inherit' }}>Align:</Typography>
                {['left', 'center', 'right', 'justify'].map( align => 
                    <Tooltip title={align}>
                        {align === alignValue ?
                            <IconButton onClick={() => handleAlignClick(align)} sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': { backgroundColor: 'primary.dark',
                                },
                                borderRadius: '25%',
                                padding: '6px',
                            }} >
                                {getAlignIcon(align)}
                            </IconButton>
                            :
                            <IconButton onClick={() => handleAlignClick(align)} sx={{
                                borderRadius: '25%',
                                padding: '6px',
                            }}
                                >
                                {getAlignIcon(align)}
                            </IconButton>
                        }
                    </Tooltip>
                )}
            </Box>
            }
            { ['entry','row','tbody', 'thead', 'tfoot'].includes(propertyNode.tag)  &&
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '110px', marginRight: 0, fontSize: 'inherit', textWrap: 'nowrap' }}>Vertical Align:</Typography>
                {['top', 'middle', 'bottom'].map( valign => 
                    <Tooltip title={valign}>
                        {valign === valignValue ?
                            <IconButton onClick={() => handleValignClick(valign)} sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': { backgroundColor: 'primary.dark',
                                },
                                borderRadius: '25%',
                                padding: '6px',
                            }} >
                                {getValignIcon(valign)}
                            </IconButton>
                            :
                            <IconButton onClick={() => handleValignClick(valign)} sx={{
                                borderRadius: '25%',
                                padding: '6px',
                            }}
                                >
                                {getValignIcon(valign)}
                            </IconButton>
                        }
                    </Tooltip>
                )}
            </Box>
            }
            { ['entry','tgroup','colspec', 'table'].includes(propertyNode.tag) &&
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '120px', marginRight: 0, fontSize: 'inherit', textWrap: 'nowrap' }}>Right Border:</Typography>
                {['1', '0'].map( colsep => 
                    <Tooltip title={getColsepTitle(colsep)}>
                        {colsep === colsepValue ?
                            <IconButton onClick={() => handleColsepClick(colsep)} sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': { backgroundColor: 'primary.dark',
                                },
                                borderRadius: '25%',
                                padding: '6px',
                            }} >
                                {getColsepIcon(colsep)}
                            </IconButton>
                            :
                            <IconButton onClick={() => handleColsepClick(colsep)} sx={{
                                borderRadius: '25%',
                                padding: '6px',
                            }}
                                >
                                {getColsepIcon(colsep)}
                            </IconButton>
                        }
                    </Tooltip>
                )}
            </Box>
            }
            { ['entry','row','tgroup','colspec', 'table'].includes(propertyNode.tag)  &&
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '120px', marginRight: 0, fontSize: 'inherit', textWrap: 'nowrap' }}>Bottom Border:</Typography>
                {['1', '0'].map( rowsep => 
                    <Tooltip title={getRowsepTitle(rowsep)}>
                        {rowsep === rowsepValue ?
                            <IconButton onClick={() => handleRowsepClick(rowsep)} sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': { backgroundColor: 'primary.dark',
                                },
                                borderRadius: '25%',
                                padding: '6px',
                            }} >
                                {getRowsepIcon(rowsep)}
                            </IconButton>
                            :
                            <IconButton onClick={() => handleRowsepClick(rowsep)} sx={{
                                borderRadius: '25%',
                                padding: '6px',
                            }}
                                >
                                {getRowsepIcon(rowsep)}
                            </IconButton>
                        }
                    </Tooltip>
                )}
            </Box>
            }
            {propertyNode.tag === 'entry' &&
                <>
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '140px', marginRight: 0, fontSize: 'inherit' }}>Row Span:</Typography>
                            <NumberField value={rowspanValue} size="small" min={1} max={100} sx={{ mr: '10px', }}
                                onIncrement={handleRowspanIncrement} onDecrement={handleRowspanDecrement}
                                onChange={handleRowspanChange} />
                    </Box>
                    
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '140px', marginRight: 0, fontSize: 'inherit' }}>Column Span:</Typography>
                            <NumberField value={colspanValue} size="small" min={1} max={100} sx={{ mr: '10px', }}
                                onIncrement={handleColspanIncrement} onDecrement={handleColspanDecrement}
                                onChange={handleColspanChange} />
                    </Box>
                    
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 2, alignItems: 'center', fontSize: 'inherit', position: 'relative', top: '0.5ex' }}>
                        <Typography sx={{ fontWeight: 'bold', marginRight: 0, fontSize: 'inherit' }}>Background</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', marginRight: 1, marginTop: 0, alignItems: 'center', fontSize: 'inherit' }}>
                        <Typography sx={{ fontWeight: 'bold', minWidth: '45px', marginRight: 0, fontSize: 'inherit' }}>Color:</Typography>
                        <TextField value={convertColor(bgcolorValue)}
                            variant="standard"
                            fullWidth
                            slotProps={{
                                input: {
                                    readOnly: true,
                                    sx: { fontSize: 'inherit', },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Tooltip title="Choose color">
                                                <IconButton onClick={handleColorClick} sx={{ fontSize: '16px' }}>
                                                    <Brightness1Icon fontSize="small" sx={{
                                                        color: bgcolorValue && bgcolorValue !== '' ? bgcolorValue : '#FFF',
                                                        fontSize: 'inherit', border: '1px gray solid', borderRadius: '10px'
                                                    }} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Clear">
                                                <IconButton onClick={handleColorClearClick} sx={{ fontSize: '16px' }}>
                                                    <ClearIcon fontSize="small" sx={{
                                                        fontSize: 'inherit',
                                                    }} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                },
                            }} />
                    </Box>
                </>
            }
            {['entry', 'row'].includes(propertyNode.tag) && 
                <>
                    <Box sx={{marginRight: 1, marginTop: 4, fontSize: 'inherit', borderTop: '1px solid rgba(0, 0, 0, 0.16)', paddingTop: 1}}>
                        <Typography sx={{ fontWeight: 'bold', width: '140px', marginRight: 0, fontSize: '105%' }}>Row</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1, marginTop: 1,  }}>
                        <Typography sx={{ fontWeight: 'bold', width: '80px', marginRight: 0, fontSize: 'inherit', pl: 2 }}>Insert:</Typography>
                            <Tooltip title="Before">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'insertRowBefore')}><span className="xui-edit-icon-16 xui-insertRowBefore-16"></span></IconButton>
                            </Tooltip>
                            <Tooltip title="After">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'insertRowAfter')}><span className="xui-edit-icon-16 xui-insertRowAfter-16"></span></IconButton>
                            </Tooltip>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1, marginTop: 1,  }}>
                        <Typography sx={{ fontWeight: 'bold', width: '80px', marginRight: 0, fontSize: 'inherit', pl: 2 }}>Edit:</Typography>
                            <Tooltip title="Cut">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'cutRow')}><span className="xui-edit-icon-16 xui-cut-16"></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Copy">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'copyRow')}><span className="xui-edit-icon-16 xui-copy-16"></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Paste Before">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'pasteRowBefore')} disabled={!pasteRowBeforeEnable}>
                                    <span className="xui-edit-icon-16 xui-pasteBefore-16" style={{filter: pasteRowBeforeEnable ? 'none' : 'grayscale(100%) contrast(50%)'}}></span>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Paste After">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'pasteRowAfter')}  disabled={!pasteRowAfterEnable}>
                                    <span className="xui-edit-icon-16 xui-pasteAfter-16" style={{filter: pasteRowBeforeEnable ? 'none' : 'grayscale(100%) contrast(50%)'}}></span>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'deleteRow')}><span className="xui-edit-icon-16 xui-deleteRow-16"></span></IconButton>
                            </Tooltip>
                    </Box>
                </>
            }
            {['entry'].includes(propertyNode.tag) && 
                <>
                    <Box sx={{marginRight: 1, marginTop: 4, fontSize: 'inherit', borderTop: '1px solid rgba(0, 0, 0, 0.16)', paddingTop: 1}}>
                        <Typography sx={{ fontWeight: 'bold', width: '140px', marginRight: 0, fontSize: '105%' }}>Column</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1, marginTop: 1,  }}>
                        <Typography sx={{ fontWeight: 'bold', width: '80px', marginRight: 0, fontSize: 'inherit', pl: 2 }}>Insert:</Typography>
                            <Tooltip title="Before">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'insertColumnBefore')}>
                                    <span className="xui-edit-icon-16 xui-insertColumnBefore-16" ></span>
                                    </IconButton>
                            </Tooltip>
                            <Tooltip title="After">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'insertColumnAfter')}><span className="xui-edit-icon-16 xui-insertColumnAfter-16"></span></IconButton>
                            </Tooltip>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1, marginTop: 1,  paddingBottom: 3}}>
                        <Typography sx={{ fontWeight: 'bold', width: '80px', marginRight: 0, fontSize: 'inherit', pl: 2 }}>Edit:</Typography>
                            <Tooltip title="Cut">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'cutColumn')}><span className="xui-edit-icon-16 xui-cut-16"></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Copy">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'copyColumn')}><span className="xui-edit-icon-16 xui-copy-16"></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Paste Before">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'pasteColumnBefore')}  disabled={!pasteColumnBeforeEnable}>
                                    <span className="xui-edit-icon-16 xui-pasteBefore-16" style={{filter: pasteColumnBeforeEnable ? 'none' : 'grayscale(100%) contrast(50%)'}}></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Paste After">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'pasteColumnAfter')}  disabled={!pasteColumnAfterEnable}>
                                    <span className="xui-edit-icon-16 xui-pasteAfter-16" style={{filter: pasteColumnAfterEnable ? 'none' : 'grayscale(100%) contrast(50%)'}}></span></IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <IconButton onClick={() => handleRunCommand('ucs.tableEdit', 'deleteColumn')}><span className="xui-edit-icon-16 xui-deleteColumn-16"></span></IconButton>
                            </Tooltip>
                    </Box>
                </>
            }
            <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
        </Box>
    );
}

export { TableEntryPanel, CreateTableDialog };